import { Navigate } from "react-router-dom";
import { storage } from "../utils/storage";
import { AuthInfo } from "../types";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'ADMIN' | 'OPERATOR' | 'DEREGISTER';
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const auth = storage.getObject<AuthInfo>('portal_rs_auth');

  if (!auth?.token) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && auth.userType !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
